export function transformIsoDate(date: string): string {
  return date.replace(/-/g, '\/').replace(/T.+/, '');
}
